import { useParams } from "react-router-dom";
import Layout from "../layouts/layout";
import Create from "../containers/_services/create";
import styles from "../styles/_screens/serviceCreate.module.scss";

const ServiceCreate = () => {
  const { serviceId } = useParams();

  let businessId = localStorage.getItem("user_id");
  businessId = JSON.parse(businessId);

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.card}>
          <Create
            isOpen={serviceId || "create"}
            businessId={businessId}
          />
        </div>
      </div>
    </Layout>
  );
};

export default ServiceCreate;
